import React, { useState, Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Swal from "sweetalert2";
import HelpdeskForm from "./components/HelpdeskForm"; // ⬅️ tambahkan import
import { confirmAction } from "./components/utils/confirmAction";
import "./App.css";
import UpdateButton from "./components/UpdateButton";

import Login from "./components/Login";
import LandingPage from "./components/LandingPage";

const Dashboard = lazy(() => import("./components/Dashboard"));
const Profil = lazy(() => import("./components/Profil"));
const Cuti = lazy(() => import("./components/Cuti"));
const Admin = lazy(() => import("./components/Admin"));
const GlobalButton = lazy(() => import("./components/GlobalButton"));
const Sidebar = lazy(() => import("./components/Sidebar"));
const Topbar = lazy(() => import("./components/Topbar"));
const MobileNav = lazy(() => import("./components/MobileNav"));

function App() {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogin = (id) => setUser(id);

  const handleLogout = async () => {
    const confirmed = await confirmAction({
      title: "Keluar Aplikasi?",
      text: "Apakah Anda yakin ingin keluar?",
      confirmText: "Ya, Keluar",
      cancelText: "Batal",
    });

    if (confirmed) {
      localStorage.removeItem("user");
      setUser(null);
      Swal.fire("Berhasil keluar!", "", "success");
    }
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <Router>
      <UpdateButton />

      <Routes>
        {/* Landing Page default */}
        <Route path="/" element={<LandingPage />} />

        {/* Helpdesk bisa diakses publik */}
  <Route path="/helpdesk" element={<HelpdeskForm />} />

        {/* Aplikasi pribadi di /app */}
        <Route
          path="/app/*"
          element={
            user ? (
              <div className="app-wrapper">
                <Sidebar
                  isOpen={sidebarOpen}
                  toggleSidebar={toggleSidebar}
                  onLogout={handleLogout}
                  user={user}
                />
                <div className="main-content">
                  <Topbar
                    user={user}
                    onLogout={handleLogout}
                    onToggleSidebar={toggleSidebar}
                  />
                  <div className="content-body">
                    <Suspense fallback={<div>Loading...</div>}>
                      <Routes>
                        <Route path="/" element={<Dashboard user={user} />} />
                        <Route path="/profil" element={<Profil user={user} />} />
                        <Route path="/cuti" element={<Cuti user={user} />} />
                        <Route path="/admin" element={<Admin user={user} />} />
                        <Route path="/test-button" element={<GlobalButton />} />
                        <Route path="*" element={<Navigate to="/app" />} />
                      </Routes>
                      <Sidebar
                        isOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                        onLogout={handleLogout}
                        user={user}
                      />
                      <MobileNav user={user} />
                    </Suspense>
                  </div>
                </div>
                <MobileNav user={user} />
              </div>
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />

        {/* Jika salah alamat, kembalikan ke landing */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
